/* eslint-disable react/prop-types */
import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Chip,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import moment from "moment";
import { useQuery } from "@apollo/client";

import { GET_COURSE_INQUIRY_DETAILS } from "graphql/query/admin";

const InfoRow = ({ label, value }) => (
  <Grid container style={{ marginBottom: 10 }}>
    <Grid item xs={4} sm={3}>
      <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555" }}>{label}</Typography>
    </Grid>
    <Grid item xs={8} sm={9}>
      <Typography style={{ fontSize: 14 }}>{value || "N/A"}</Typography>
    </Grid>
  </Grid>
);

const ViewInquiry = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const courseInquiryId = state?.id;

  const { data, loading } = useQuery(GET_COURSE_INQUIRY_DETAILS, {
    variables: { courseInquiryId },
    skip: !courseInquiryId,
    fetchPolicy: "network-only",
  });

  const inquiry = data?.courseInquiry;

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="70vh">
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!inquiry) {
    return (
      <Container maxWidth={false} disableGutters style={{ margin: "0 2%" }}>
        <Typography>No inquiry data found.</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth={false} disableGutters style={{ margin: "0 2%", minHeight: "70vh" }}>
      {/* Breadcrumb */}
      <Typography style={{ fontWeight: "bold", display: "flex", alignItems: "center", flexWrap: "wrap", marginBottom: 16 }}>
        <Link to="/admin/course" style={{ color: "black", textDecoration: "none", marginRight: 4 }}>Course</Link>
        &gt;
        <span style={{ fontWeight: "bold", marginLeft: 4 }}>Inquiry Detail</span>
      </Typography>

      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        style={{ marginBottom: 16 }}
        variant="outlined"
        size="small"
      >
        Back
      </Button>

      <Box style={{ background: "#fff", borderRadius: 8, padding: 24, boxShadow: "0 1px 4px rgba(0,0,0,0.1)" }}>
        <Box style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            {inquiry.title || "Inquiry Detail"}
          </Typography>
          {inquiry.status && (
            <Chip
              label={inquiry.status}
              size="small"
              style={{ background: "#e3f2fd", color: "#1565c0", fontWeight: 600 }}
            />
          )}
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <InfoRow label="Inquiry ID" value={inquiry.id} />
            <InfoRow label="User ID" value={inquiry.userId} />
            <InfoRow label="Email" value={inquiry.email} />
            <InfoRow label="Mobile" value={inquiry.mobile} />
            <InfoRow label="Status" value={inquiry.status} />
            <InfoRow
              label="Created At"
              value={inquiry.createdAt ? moment(inquiry.createdAt).format("DD/MM/YYYY HH:mm") : null}
            />
            <InfoRow
              label="Updated At"
              value={inquiry.updatedAt ? moment(inquiry.updatedAt).format("DD/MM/YYYY HH:mm") : null}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography style={{ fontWeight: 600, fontSize: 14, color: "#555", marginBottom: 4 }}>
              Message
            </Typography>
            <Typography style={{ fontSize: 14 }}>
              {inquiry.message || "N/A"}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default ViewInquiry;
